<template>
	<v-menu offset-y :close-on-content-click="false">
		<template v-slot:activator = "{ on, attrs }">	    		
			<v-btn small v-on   = "on" v-bind="attrs">
			   	<v-tooltip bottom>
		    		<template v-slot:activator = "{ on, attrs }">	
	    				<v-icon small v-on = "on" v-bind="attrs"> mdi-table-settings</v-icon>
					</template>
		    		<span>
		    			{{ $ml.get('drawable_options') }}
		    		</span>
		    	</v-tooltip>
	    	</v-btn>
    	</template>
		    	<v-list dense flat>
		    		<v-list-item-group >
		    		 	<v-list-item dense
		    		 		v-for  		= "(item_sub, idx_sub) of list"
		    		 		:key 		= "idx_sub"
						>					
					       <template v-slot:default = "{ active }">
					           <v-list-item-action class = "my-0">
		    		 					<!-- @click 		= "renderGrid()" -->
					              	<v-checkbox dense
					                	v-model 	= "currentOptions[item_sub.key]"				                				                	
					              	></v-checkbox>
					            </v-list-item-action>	
					            <v-list-item-content>			             
						         	<v-list-item-title 
						         		v-text = "$ml.get(item_sub.text)"
						         	></v-list-item-title>
					         </v-list-item-content>
					    	</template>
				        </v-list-item>				   
			    </v-list-item-group>
				    </v-list-item-group>
		    	</v-list>
    		</v-menu>
</template>
<script type="text/javascript">
	export default{
		name : "MenuOptionsDashboard",
		data : (vm)=>({
			grid_options 		: {
				draggable  			: false,
				resizable 			: true,
				// responsive 			: false,
				prevent_collision 	: false,
				vertical_compact 	: false,

			},
			list : [
				{
					key 	: "draggable",
					text 	: "draggable",
					action 	: "option_draggable"

				},
				{
					key 	: "resizable",
					text 	: "resizable",
					action 	: "option_draggable"

				},
					// -responsive
				{
					key 	: "prevent_collision",
					text 	: "prevent_collision",
					action 	: "option_draggable"

				},
				{
					key 	: "vertical_compact",
					text 	: "vertical_compact",
					action 	: "option_draggable"

				},
			],
			menu : false,			
		}),
		computed:{
			currentOptions:{
				get(){
					this.$store.commit("Dashboard/saveLocalProfile");
					return this.$store.getters["Dashboard/getCurrentProfile"].options
				},
				set(value){
					this.$store.commit("Dashboard/setOptions", value);	
				}

			}
		},
		methods:{
			renderGrid(){
				
			},
		},

	}
</script>